module.exports = __webpack_public_path__ + "static/media/importacao-de-clientes.addae4ad.xlsx";